// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getNotifyStyle } from "@sc/App/Components/Notify";
import { recentOrdersStyles } from "@sc/Overrides/Widgets/Common/RecentOrders";
import ArrowRight from "@sc/XDL/Icons/ArrowRight";
import { createLinkIconStyles, mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

recentOrdersStyles.cardList = {
    gridContainer: {
        gap: 0,
    },
};

recentOrdersStyles.viewAllLink = {
    ...createLinkIconStyles(ArrowRight, {
        css: css`
            margin-bottom: 16px;
        `,
        icon: {
            position: "right",
        },
    }),
};

recentOrdersStyles.noOrdersFoundText = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin: 0;
        `,
    }),
};

recentOrdersStyles.dataTable = {
    css: css`
        td[class^="DataTableCellBase"] {
            & > ${TypographyStyle}:empty:after {
                content: "- -";
            }
        }
    `,
};

recentOrdersStyles.noOrdersFoundGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};
